var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoweredFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215.4 48",
    style: {
      enableBackground: "new 0 0 215.4 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#11111E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.7,17c-0.4-1.3-0.9-2.5-1.4-3.6c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0,0C170.1,5.3,162.1,0,152.7,0h-91 c-9.3,0-17.4,5.3-21.4,13.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.7,1.3-1.2,2.7-1.7,4.2C28,41.7,5.5,48,5.5,48h56.3h12.6h65.8h12.6h56.3 C209.1,48,186.4,41.6,175.7,17z"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDIxNS40IDQ4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyMTUuNCA0ODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6IzExMTExRTt9DQo8L3N0eWxlPg0KPHBhdGggY2xhc3M9InN0MCIgZD0iTTAsNDgiLz4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNzUuNywxN2MtMC40LTEuMy0wLjktMi41LTEuNC0zLjZjMC0wLjEtMC4xLTAuMi0wLjEtMC4zYzAsMCwwLDAsMCwwQzE3MC4xLDUuMywxNjIuMSwwLDE1Mi43LDBoLTkxDQoJYy05LjMsMC0xNy40LDUuMy0yMS40LDEzLjFjMCwwLDAsMCwwLDBjMCwwLDAsMCwwLDBjLTAuNywxLjMtMS4yLDIuNy0xLjcsNC4yQzI4LDQxLjcsNS41LDQ4LDUuNSw0OGg1Ni4zaDEyLjZoNjUuOGgxMi42aDU2LjMNCglDMjA5LjEsNDgsMTg2LjQsNDEuNiwxNzUuNywxN3oiLz4NCjwvc3ZnPg0K";
export { SvgPoweredFooter as ReactComponent };